<template>
  <BaseSelect
    :classes="{
      wrapper: props.classWrapper,
    }"
    v-model="model"
    :label="props.label"
    :placeholder="props.placeholder"
    shape="rounded"
    :disabled="props.disabled"
    :error="props.error"
    @input="emit('update:modelValue', $event.target.value)"
  >
    <option
      :value="option.value"
      v-for="(option, index) in options"
      :key="index"
    >
      {{ option.text }}
    </option>
  </BaseSelect>
</template>

<script setup lang="ts">
import { reactive } from 'vue'

const model = defineModel({ required: true, default: '' })
const emit = defineEmits(['update:modelValue'])

const { t } = useI18n()

const props = withDefaults(
  defineProps<{
    disabled?: boolean
    nullable?: boolean
    allVisible?: boolean
    noGender?: boolean
    error?: string
    placeholder?: string
    label?: string
    classWrapper?: string
  }>(),
  {
    disabled: false,
    nullable: false,
    allVisible: true,
    noGender: false,
    error: '',
    placeholder: '',
    label: '',
    classWrapper: 'w-full',
  },
)

const options = reactive([
  { text: t('male'), value: 'M' },
  { text: t('female'), value: 'F' },
])
if (props.allVisible) {
  options.unshift({ text: t('all'), value: 'ALL' })
}
if (props.nullable) {
  options.unshift({ text: t('select'), value: '' })
}
if (props.noGender) {
  options.unshift({ text: t('unspecified'), value: 'N' })
}
</script>
